var map = {
	"./": 8171,
	"./fs-adapter": 5913,
	"./fs-adapter.ts": 5913,
	"./gather": 7630,
	"./gather.ts": 7630,
	"./index": 8171,
	"./index.ts": 8171,
	"./m-adapter": 6978,
	"./m-adapter.ts": 6978,
	"./sy-adapter": 2588,
	"./sy-adapter.ts": 2588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1298;